import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = () => {
    console.log('LoginPage: 로그인 성공, 홈으로 이동');
    navigate('/');
  };

  const handleSwitchToRegister = () => {
    navigate('/register');
  };

  return (
    <LoginForm 
      onSuccess={handleLoginSuccess}
      onSwitchToRegister={handleSwitchToRegister}
    />
  );
};

export default LoginPage;


